

import React from "react";
import { GoogleMap, MarkerF } from "@react-google-maps/api";

const MapComponent = ({ selectedLocation, setSelectedLocation, reverseGeocode }) => {
  const onMarkerDragEnd = async (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const latLng = { lat, lng };

    // Update location details with reverse geocoding
    reverseGeocode(latLng);
  };

  return (
    <div style={{ marginTop: "20px", height: "400px", width: "100%" }}>
      <GoogleMap
        mapContainerStyle={{ height: "100%", width: "100%" }}
        center={selectedLocation}
        zoom={14}
      >
        <MarkerF
          position={selectedLocation}
          draggable={true}
          onDragEnd={onMarkerDragEnd}
        />
      </GoogleMap>
    </div>
  );
};

export default MapComponent;


